import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { DatabaseApiServiceService } from '../../../database-api-service.service';
import Swal from 'sweetalert2'
import { Constants } from "src/app/constants";
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  myUserForm: FormGroup

  constructor(private fb: FormBuilder, private databaseService: DatabaseApiServiceService, private router: Router) { }

  ngOnInit(): void {
    this.myUserForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  changePassword(){
    if(this.myUserForm.value.username === ''){
      Swal.fire({
        title: 'Error!',
        text: 'Please fill out username field to change password.',
        icon: 'error',
        confirmButtonText: 'Cool'
      })
      return;
    }

    this.databaseService.changePassword(this.myUserForm.value.username, this.myUserForm.value.password).subscribe((result) => {
      console.log(result);
      if(result.status == Constants.SUCCESS_CODE){
        Swal.fire({
          title: 'Success',
          text: Constants.CHANGE_PASSWORD_SUCCESS_MESSAGE,
          icon: 'success',
          confirmButtonText: 'Cool Beans'
        })
        this.router.navigate(['auth/login']);
      }
      else{
        Swal.fire({
          title: 'Error!',
          text: result.message,
          icon: 'error',
          confirmButtonText: 'Okay'
        })
        return;
      }
    })
  }

}
